import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RealtimeProvider } from "../../hooks/useRealtime";
import { ONBOARDING_PATH } from "../../utils/paymentNav";

const IsAuthenticated = () => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    const params = new URLSearchParams();
    const attemptedPath = `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`;
    params.set("returnTo", attemptedPath);

    // Direct access to /onboarding while logged out most commonly comes
    // from generic CTAs like "Get Started". Seed the onboarding intent so
    // post-auth redirects stay deterministic.
    if (location.pathname === ONBOARDING_PATH && !params.get("intent")) {
      params.set("intent", "get-started");
    }

    return <Navigate to={`/sign-in?${params.toString()}`} replace />;
  }

  return (
    <RealtimeProvider>
      <Outlet />
    </RealtimeProvider>
  );
};

export default IsAuthenticated;
